export const INTAKE_VIEWED = 'Intake Viewed';
export const INTAKE_PAYMENT_STARTED = 'Intake Payment Started';
export const INTAKE_PAYMENT_COMPLETE = 'Intake Payment Complete';
export const INTAKE_ACCOUNT_LINKING_STARTED = 'Intake Account Linking Started';
export const INTAKE_COMPLETE = 'Intake Complete';
